<template>
    <div>
        <CollapseConfirmData
            :codeId="code"
            @removeService="removeService"
        >
            <template #content>
                <h4 class="mb-2.5 md:mb-4">
                    信用卡資訊
                </h4>

                <ResultList class="md:hidden break-all">
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3 flex-shrink-0">
                            發卡機構
                        </p>
                        <span class="text-gray-900"> {{ data.after.cardBankName }}</span>
                    </li>
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3 flex-shrink-0">
                            卡號
                        </p>
                        <span class="text-gray-900"> {{ formatCreditCardNo(data.after.cardNo) }}</span>
                    </li>
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3  flex-shrink-0">
                            有效月年
                        </p>
                        <span class="text-gray-900">{{ `${data.after.fullMonth}月 / ${data.after.fullYear}年` }} </span>
                    </li>
                </ResultList>

                <TableBase
                    class="hidden md:block"
                    :isDashed="true"
                    :cursorPointer="false"
                >
                    <template #thead>
                        <tr class="text-sm lg:text-base">
                            <th>
                                發卡機構
                            </th>
                            <th>
                                卡號
                            </th>
                            <th>
                                有效月年
                            </th>
                        </tr>
                    </template>
                    <template #tbody>
                        <tr class="text-base xs:text-lg md:text-base lg:text-lg text-gray-900">
                            <td class="break-all">
                                {{ data.after.cardBankName }}
                            </td>
                            <td>
                                {{ formatCreditCardNo(data.after.cardNo) }}
                            </td>
                            <td>
                                {{ `${data.after.fullMonth}月 / ${data.after.fullYear}年` }}
                            </td>
                        </tr>
                    </template>
                </TableBase>

                <h4 class="mt-6 mb-2.5 md:mb-4">
                    以下為此次欲延長信用卡效期的保單
                </h4>
                <TableBase
                    :isDashed="true"
                    :cursorPointer="false"
                >
                    <template #thead>
                        <tr class="text-sm lg:text-base">
                            <th>
                                保單號碼
                            </th>
                            <th class="hidden md:table-cell">
                                主約險種
                            </th>
                            <th>
                                被保險人
                            </th>
                        </tr>
                    </template>
                    <template #tbody>
                        <tr
                            v-for="(item, index) in data.after.creditCardExpList"
                            :key="index"
                            class="text-base xs:text-lg md:text-base lg:text-lg text-gray-900"
                        >
                            <td class="break-all">
                                {{ item.fullPolicyNo }}
                            </td>
                            <td class="hidden md:table-cell">
                                {{ item.itemName }}
                            </td>
                            <td class="">
                                {{ item.name }}
                            </td>
                        </tr>
                    </template>
                </TableBase>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ResultList from '@/components/template/ResultList.vue';
import TableBase from '@/components/table/TableBase.vue';
import codeList from '@/json/codeList.js';
import { formatCreditCardNo } from '@/utils/number/formatCreditCardNo';

export default {
    name: 'CreditCard',
    components: {
        CollapseConfirmData,
        ResultList,
        TableBase
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref(codeList.CREDIT_CARD_EXP);
        const removeService = () => {
            emit('removeService', code.value);
        };
        return {
            code,
            data,
            removeService,
            formatCreditCardNo
        };
    },
};
</script>
